module.exports = __webpack_public_path__ + "img/icon_thongke.52b8bd6f.svg";